import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const sidebarWrapper = style({
  position: 'relative',
  backgroundColor: vars.color.white,
  borderRadius: vars.blocks.radius,
  boxShadow: vars.shadow,
  width: 280,
  minWidth: 200,
  height: '100%'
})

export const sidebar = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  position: 'absolute',
  top: 4,
  left: 4,
  right: 4,
  bottom: 4,
  paddingRight: 8,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: `${vars.color.mediumDarker} transparent`
})

export const sidebarSection = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 4
})

export const sidebarSectionTitle = style({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '4px 12px',
  fontSize: vars.font.bodyBold.size,
  fontWeight: vars.font.bodyBold.weight,
  color: vars.color.dark
})

export const sidebarLink = style({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 12px',
  borderRadius: vars.blocks.smallRadius,
  textDecoration: 'none',
  color: vars.color.dark,
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  transition: 'background-color 0.2s',
  ':hover': {
    backgroundColor: vars.color.mainHover
  }
})

export const sidebarLinkActive = style({
  color: vars.color.primary,
  fontWeight: vars.font.bodyBold.weight,
  ':hover': {
    backgroundColor: 'inherit'
  }
})

export const settingsPageWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 18,
  width: '100%'
})

export const searchRow = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  position: 'sticky',
  padding: '4px 0',
  top: 0,
  backgroundColor: vars.color.white,
  zIndex: 1000
})
